import * as Ajax from './ajax'
const STEKI_METER_HEIGHTS = ['0%', '25%', '33%', '40%', '48%', '56%', '65%', '74%', '83%', '92%', '100%']

/**
 * 実行可能状態
 */
$(document).ready(function () {
  /**
   * kartes_controller
   */
  if (document.body.dataset.controller == 'kartes') {
    /**
     * show action
     */
    if (document.body.dataset.action == 'show') {
      // 選択中のカルテ画像をタップ
      $('.karte-main-photo img').click(function () {
        $('.download-image-confirm-dialog').show()
      })

      // カルテ一覧の写真をタップ
      $('.karte-main-photos .exists a').click(function (e) {
        // タップしたサムネイルをアクティブに
        $('.karte-main-photos li').removeClass('active')
        var $photoLi = $(this).parent('li')
        $photoLi.addClass('active')

        // メイン画像を切替
        var imageUrl = $(this).find('img').attr('src')
        $('.karte-main-photo img').attr('src', imageUrl)

        // 画像ダウンロードボタンの画像リンクを変更
        $('.download-image-confirm-dialog .yes').attr('href', imageUrl)

        // ステキボタンのdataを書き換え
        var likeCount = ($photoLi.attr('data-like-count').length === 0) ? '0' : $photoLi.attr('data-like-count')
        var $loveButton = $('.photo-love-button')
        $loveButton.attr('data-suidbase', $photoLi.attr('data-suidbase'))
        $loveButton.attr('data-photoid', $photoLi.attr('data-photoid'))
        $loveButton.attr('data-like-count', likeCount)
        var $maskColor = $loveButton.find('.mask-color')
        if (Number(likeCount) < 10) {
          $maskColor.removeClass('max')
          $loveButton.removeClass('suteki-scale')
        } else {
          $maskColor.addClass('max')
          $loveButton.addClass('suteki-scale')
        }
        $maskColor.removeAttr('style')
        $maskColor.css('height', STEKI_METER_HEIGHTS[likeCount])
      })

      // 画像ダウンロードダイアログ-[はい]をタップ
      $('.download-image-confirm-dialog .yes').click(function () {
        $('.download-image-confirm-dialog').hide()
      })

      // 画像ダウンロードダイアログ-[キャンセル]をタップ
      $('.download-image-confirm-dialog .cancel').click(function () {
        $('.download-image-confirm-dialog').hide()
      })

      // プライベートカルテ写真編集時
      $('.private-karte-photos').on('click', '.modify-private-karte-photo', function (e) {
        $('.private-karte-photo-edit-dialog').show()
      })

      // プライベートカルテ写真を切り替える
      $('.private-karte-photos').on('click', '.private-karte-main-photos a', function (e) {
        $('.private-karte-main-photos li').removeClass('active')
        var $photoLi = $(this).parent('li')
        $photoLi.addClass('active')
        var imageUrl = $(this).find('img').attr('src')
        // メイン画像を切替
        $('.private-karte-main-photo img').attr('src', imageUrl)
        $('.edit-private-photo').attr('data-photoid', $photoLi.attr('data-photoid'))
        $('.delete-private-photo').attr('data-photoid', $photoLi.attr('data-photoid'))
      })

      // プライベートカルテ写真削除
      $('.delete-private-photo').click(function (e) {
        var kSuidbase = $('.private-area').attr('data-ksuidbase')
        var kSuid = $('.private-area').attr('data-ksuid')
        var photoid = $(this).attr('data-photoid')
        if (!confirm('本当に削除しますか？')) {
          // キャンセルの時の処理
          return false
        } else {
          // 画像削除
          Ajax.deletePrivateKartePhoto(kSuid, kSuidbase, photoid, (result) => {
            // nothing to do
          })
        }
      })

      // プライベートカルテメモ編集ボタン押下
      $('.private-area').on('click', '.edit-private-karte-memo', function (e) {
        $('.private-karte-memo-dialog').show()
      });
    }

    // ----------------------------------------
    // ステキボタン
    // ----------------------------------------

    // カルテ写真ステキボタン押下
    $('.photo-love-button.clickable').click(function () {
      var kSuid = $(this).attr('data-ksuid')
      var kSuidbase = $(this).attr('data-ksuidbase')
      var suidbase = $(this).attr('data-suidbase')
      var photoid = $(this).attr('data-photoid')
      var likeCount = $(this).attr('data-like-count')
      if (likeCount >= 10) {
        return
      }
      // ステキボタンと写真リスト側のdata-like-countをカウントアップ
      var uppedLikeCount = ++likeCount
      $(this).attr('data-like-count', uppedLikeCount)
      $('.karte-main-photos li.active').attr('data-like-count', uppedLikeCount)
      setStekiWithAnimate($(this), uppedLikeCount)
      if (uppedLikeCount >= 10) {
        showCheerDialog()
      }
      Ajax.setKartePhotoLike(kSuid, kSuidbase, suidbase, photoid, uppedLikeCount, (result) => {
        // nothing to do
      })
    })

    // カルテ共有コメントのステキボタン押下
    $('.comment-love-button.clickable').click(function () {
      var kSuid = $(this).attr('data-ksuid')
      var kSuidbase = $(this).attr('data-ksuidbase')
      var suidbase = $(this).attr('data-suidbase')
      var likeCount = $(this).attr('data-like-count')
      if (likeCount >= 10) {
        return
      }
      // ステキボタンと写真リスト側のdata-like-countをカウントアップ
      var uppedLikeCount = ++likeCount
      $(this).attr('data-like-count', uppedLikeCount)
      setStekiWithAnimate($(this), uppedLikeCount)
      if (uppedLikeCount >= 10) {
        showCheerDialog()
      }
      Ajax.setKarteCommentLike(kSuid, kSuidbase, suidbase, uppedLikeCount, (result) => {
        // nothing to do
      })
    })

    

    $('.no-cheer').click(function () {
      $('.cheer-for-stylist-dialog-wrap').fadeOut()
      $('.cheer-for-stylist-dialog').fadeOut()
    })

    /**
     * index action
     */
    if (document.body.dataset.action == 'index') {
      // 画像のアップロード
      $('.image-photo').on('click', function() {
        $('.file-photo').click()
      })
      $('.file-photo').on('change', function() {
        const file = $('.file-photo')[0].files[0]
        const reader = new FileReader();
        reader.onload = function() {
          Ajax.uploadUserPhoto(reader.result, function(s3Path) {
            $('.image-photo').attr('src', s3Path)
          })
        }
        reader.readAsDataURL(file)
      })

      //STEKINA_PATH
      // クリックした予約の情報をダイアログに反映(フルビューにする)
      const stekina_profile_path = '/user/kartes'
      // 確認ダイアログを開く
      $('.link-confirm').on('click', function () {
        var reserve_id = $(this).data('reserveId')
        console.log(getUrlParameter('channel_id'))
        const url = stekina_profile_path + '/line_channel?channel_id=' + getUrlParameter('channel_id')
        $.ajax({
          url: url,
          type: 'get',
        }).done(function (data) {
          var line_app_id_fullview = data["line_app_id_fullview"]
          if (line_app_id_fullview) {
            //Liff fullview 遷移
            var line_liff_fullview_link = "https://liff.line.me/" + line_app_id_fullview + "?move_to=chat&r_reserve_id=" + reserve_id + "&line_app_id=" + line_app_id_fullview

            $('.link-message-confirm').attr('href', line_liff_fullview_link)
          } else {
            $('.link-message-confirm').attr('href', '/user/reserves/' + reserve_id)
          }
        }).fail((jqXHR, textStatus, errorThrown) => {
          console.log('fail', jqXHR.status);
          $('.link-message-confirm').attr('href', '/user/reserves/' + reserve_id)
        })

        $('.link-message-confirm').attr("data-reserve-id", reserve_id)
      

        if ($(this).data('salon-google-map-url')) {
          $('.link-map-to-salon').attr('href', encodeURI($(this).data('salon-google-map-url')))
        }
        else{ 
          $('.link-map-to-salon').attr('href', encodeURI('https://www.google.com/maps/place/' + $(this).data('address')))
        }
      

        // 開く
        $('.detail-confirm-dialog').fadeIn()
        $('.common-dialog-mykarte-bg').fadeIn()

        $(".cancel-or-change-dialog").hide()
        checkReserveCancelPermition(reserve_id);
      })

      // 確認ダイアログを閉じる
      $('.button-dialog-close,.common-dialog-mykarte-bg').on('click', function () {
        // 閉じる
        $('.detail-confirm-dialog').hide()
        $('.common-dialog-mykarte-bg').hide()
        $('.reserve-cancel-or-change-dialog').hide()
        $('.confirm-cancel-dialog').hide()
        $('.failed-cancel-reserve-dialog').hide()
      })

      // キャンセル・予約変更
      $('.cancel-or-change-dialog').on('click', function () {
        $('.detail-confirm-dialog').hide()

        var permit_cancel = $(this).data("permit-cancel")
        if (permit_cancel == "1") {
          $(".confirm-cancel-reservation-button-area").show()
        } else {
          $(".confirm-cancel-reservation-button-area").hide()
        }
        $('.reserve-cancel-or-change-dialog').show()
      })

      //キャンセル導線開始
      $('.confirm-cancel-reservation-button').on('click', function () {
        $('.reserve-cancel-or-change-dialog').hide()
        $('.confirm-cancel-dialog').show();
      })


      // キャンセル実行ボタン押下
      $('.cancel-reservation-button').on('click', function () {
        
        var reserve_id = $(".cancel-reservation-button").attr("data-cancel-reserve-id")
        var ruid = $(".wrapper-mykarte-list").data('ruid')
        $('.confirm-cancel-dialog').hide();
        cancelReservation(ruid, reserve_id)
      })

      // キャンセル完了ダイアログを閉じる
      $('.canceled-reservation-button').on('click', function () {
        $('.canceled-reserve-dialog').hide()
        $('.reserve-cancel-or-change-dialog').hide()
        location.reload();
      })

      //キャンセル失敗ダイアログでOK押下
      $('.failed-cancel-reservation-button').on('click', function () {
        // 閉じる
        $('.failed-cancel-reserve-dialog').hide()
        $('.detail-confirm-dialog').hide()
        $('.common-dialog-mykarte-bg').hide()
        $('.reserve-cancel-or-change-dialog').hide()
        $('.confirm-cancel-dialog').hide()
        location.reload();
      })

      //予約変更
      $('.change-reservation-button').on('click', function () {
        $('.reserve-cancel-or-change-dialog').hide()
        var r_reserve_id = $(".change-reservation-button").attr("data-change-reserve-id")
        changeReservation(r_reserve_id)
      })
      
      // タブ処理系
      $('.wrap-content.counseling,.wrap-content.photos').hide()
      
      $('.tab').click(function () {
        console.log("tab tap")
        $('.tab').removeClass('active')
        $(this).addClass('active')
        $('.wrap-content').hide()
        $('.wrap-content.' + $(this).data('content')).show()
        

        console.log($(this).data('content'))
        //「写真」に遷移した際に非同期で写真を取得する
        if ($(this).data('content') === "photos") {
          getKartePhotoList();
        }
        //「愛用商品リスト」に遷移した際に非同期取得する
        else if ($(this).data('content') === "purchase-history") {
          getPurchaseHistory();
        }
      });

      // デフォルトタブの指定があれば選択する
      const selectTab = $('.default-tab').data('selectTab')
      if(selectTab) {
        $('.tab[data-content=' + selectTab).click()
      }
    }
  }
})


function getKartePhotoList() {
  var ruid = $(".wrapper-mykarte-list").data('ruid')
  Ajax.getSharedKartePhotoList(ruid, (result) => {
    let html = "";
    if (result.karte_photos) {
      //写真一覧をレンダリングする
      let photos = result.karte_photos;
      
      if (photos.length > 0) {
        html += "<ul id='rizm-photos'>"
        for (var i = 0; i < photos.length; i++) {
          html += "<li>"
          html += "<a href='kartes/" + photos[i].suidbase + "/" + photos[i].k_suid + "'>"
          html += "<div>"
          html += "<img src='" + photos[i].s3_image + "'/>"
          html += "</div>"
          html += "</a>"
          html += "</li>"
        }
        html += "</ul>"
      } else {
        html += "<div class='karte-empty-image'>"
        html += "<%= image_tag 'https://limehair.jp/php74-lime/wp-content/uploads/2022/06/defaultscreen-photo.png' %>"
        html += "</div>"
      }
    } else { 
      html += "<div class='karte-empty-image'>"
      html += "<img src='https://limehair.jp/php74-lime/wp-content/uploads/2022/06/defaultscreen-photo.png'/>"
      html += "</div>"
    }
    $(".wrap-content.photos").html(html)
  })
}

function getPurchaseHistory() {

  var ruid = $(".wrapper-mykarte-list").data('ruid')
  var liff_full_url = $('input[name=liff-full-url]').val()
  Ajax.getPurchaseHistory(ruid, (result) => {
    let html = "<ul id='purchase-history-grid'>";
    let purchase_history = result.purchase_history;
    // console.log("purchase_history", purchase_history)
    for (var i = 0; i < purchase_history.length; i++) {
      let history = purchase_history[i];
      html += "<li class='purchase-history-grid-child'>"
      if (history.next_order_date) {
        html += "<a href='" + liff_full_url + "&move_to=ec_confirm_subscription&referral_suidbase=" + history.suidbase + "&product_variants_id=" + history.ec_product_variants_id + "&subscription_cycle=" + history.cycle + "'>"
      } else {
        html += "<a href='" + liff_full_url + "&move_to=ec&referral_suidbase=" + history.suidbase + "&product_variants_id=" + history.ec_product_variants_id + "'>"
      }
      html += "</div>"  
      html += "<div class='purchase-history-grid-child-overlay'>"
      if (history.next_order_date) {
        html += "<p class='purchased-category'>定期購入中</p>"
        html += "<p class='product-yotei'>次回" + history.next_order_date + "にお届け予定</p>"
      } else {
        html += "<p class='purchased-date'>" + history.purchase_date +"に購入</p>"
        html += "<p class='product-name'>" + history.variant_name +"</p>"
      }
      html += "</div>"
      html += "<img src='" + history.product_image + "'>"
      html += "</a>"
      html += "</li>"
    }
    html += "</ul>"
    $(".wrap-content.purchase-history").html(html)
  })
}


//文字のバイト数を取得する関数
function charcount(str) {
  var len = 0;
  var str = escape(str);
  for (var i = 0; i < str.length; i++, len++) {
    if (str.charAt(i) == "%") {
      if (str.charAt(++i) == "u") {
        i += 3;
        len++;
      }
      i++;
    }
  }
  return len;
}

function showCheerDialog() {
  var reviewed = $('.already-reviewed').length
  //レビュー済みの場合は表示しない
  if (reviewed == 0) {
    // 美容師さんを応援しませんかダイアログ
    $('.cheer-for-stylist-dialog-wrap').fadeIn()
    $('.cheer-for-stylist-dialog').fadeIn()

    //名前が長い時の文字数対策
    var custmername_text = $(".name-client-charcount").text();
    var custmername_count = charcount(custmername_text);
    if (custmername_count > 18) {
      $(".name-client-charcount").css('font-size', (18 - ((custmername_count - 18) * 0.37)) + 'px');
      $(".name-client-charcount").css('letter-spacing', '-0.5px');  
    }
  }
}

//
// キャンセル・予約変更導線表示制御
//
function checkReserveCancelPermition(r_reserve_id) {
  $("a.cancel-reservation-button").attr("data-cancel-reserve-id", r_reserve_id)
  $("a.change-reservation-button").attr("data-change-reserve-id", r_reserve_id)
  //キャンセルできて良いかAPIアクセス
  Ajax.checkReserveCancelPermition(r_reserve_id, (permit_cancel) => {
    if (permit_cancel) {
      $(".cancel-or-change-dialog").text("予約を変更・またはキャンセル")
      $(".cancel-or-change-dialog").data("permit-cancel", 1)
      $(".cancel-or-change-dialog").fadeIn()
    } else {
      $(".cancel-or-change-dialog").text("予約を変更する")
      $(".cancel-or-change-dialog").data("permit-cancel", 0)
      $(".cancel-or-change-dialog").fadeIn()
    }
  }, () => {
  })
}

//
// 予約キャンセル
//
function cancelReservation(ruid, r_reserve_id) {
  Ajax.cancelReservation(ruid, r_reserve_id, (data) => {
    // //キャンセル完了ダイアログ表示
    $('.common-dialog-mykarte-bg').hide()
    $('.common-dialog-mykarte-bg-untouchable').show()
    $('.canceled-reserve-dialog').show();
  }, () => {
    //キャンセル失敗
    $('.failed-cancel-reserve-dialog').show();
  })
}

//
// 予約変更
//
function changeReservation(r_reserve_id) {
  var channel_id = getUrlParameter('channel_id')
  Ajax.getUpdateReservationUrl(r_reserve_id, channel_id, (update_reserve_url) => {
    if (update_reserve_url) {
      location.href = update_reserve_url
    } else {
      $('.failed-cancel-reserve-dialog').show();
    }
  }, () => {
    $('.failed-cancel-reserve-dialog').show();
  })
}

/**
 * アニメーションつきでステキ数のセットを行う
 */
function setStekiWithAnimate (loveButton, numSteki) {
  var loveButtonParent = loveButton.parent()
  loveButton.data('num-suteki', numSteki)
  loveButton.data('num-total-suteki', numSteki)
  loveButton.addClass('sutekiscalenormal').delay(500).queue(function (next) {
    loveButton.removeClass('sutekiscalenormal')
    next()
  })

  loveButtonParent.find('.suteki-counter').animate({
    'opacity' : '1',
  }, 0)

  loveButtonParent.find('.suteki-counter').fadeIn('100')
  loveButtonParent.find('.suteki-counter').fadeOut('5000')
  loveButtonParent.find('.mask-color').css('height', STEKI_METER_HEIGHTS[numSteki])

  if (numSteki >= 10) {
    loveButtonParent.find('.flush-heart').addClass('target')
    loveButtonParent.addClass('liked', 400, 'swing', () => {
      loveButtonParent.find('.flush-heart').removeClass('target')
    })
    loveButtonParent.find('.mask-color').css('background', 'white')
    loveButtonParent.find('.love-button').addClass('suteki-scale')
    loveButtonParent.find('.suteki-counter-number').css('font-size', '30px')
  }

  loveButtonParent.find('.love-button-count-span').html(function (i, val) {
    return numSteki
  })
  loveButtonParent.find('.suteki-counter-number').html(function (i, val) {
    return numSteki
  })
}


//
// Cropper
//
$(function () {
  // 画像選択時
  var kSuidbase = ''
  var kSuid = ''
  var photoid = ''
  // 新規登録
  $('.private-karte-photos').on('change', '.launch-crop-new-image', function (e) {
    var file = e.target.files[0]
    if (file === undefined || file.type.indexOf('image') < 0) {
      alert('画像を選択してください')
      return false
    }
    kSuidbase = $('.private-area').attr('data-ksuidbase')
    kSuid = $('.private-area').attr('data-ksuid')
    photoid = $(this).attr('data-photoid')
    launchCropper(file)
  })

  // 更新
  $('.private-karte-photo-edit-dialog').on('change', '.launch-crop-edit-image', function (e) {
    $('.private-karte-photo-edit-dialog').hide()
    var file = e.target.files[0]
    if (file === undefined || file.type.indexOf('image') < 0) {
      alert('画像を選択してください')
      return false
    }
    kSuidbase = $('.private-area').attr('data-ksuidbase')
    kSuid = $('.private-area').attr('data-ksuid')
    photoid = $('.launch-crop-edit-image').attr('data-photoid')
    launchCropper(file)
  })

  function launchCropper (file) {
    var reader = new FileReader()
    // トリミング画面をフェードインさせる
    reader.onload = (function (e) {
      $('.overlay').fadeIn()
      $('.crop_modal').append($('<img>').attr({
        src: e.target.result,
        height: '100%',
        class: 'preview',
        id: 'crop_img',
        title: file.name
      }))

      var aspectRatio = 1
      initIconCrop(aspectRatio)
    })
    reader.readAsDataURL(file)
  }

  // cropper（トリミング部）のコーディング（詳しくはGitHub参照）
  var cropper
  var croppable = false
  function initIconCrop (aspectRatio) {
    cropper = new Cropper(crop_img, {
      dragMode: 'move',
      aspectRatio: aspectRatio,
      viewMode: 1,
      restore: false,
      guides: false,
      center: false,
      highlight: false,
      cropBoxMovable: false,
      cropBoxResizable: false,
      ready: function () {
        croppable = true
      }
    })
  }

  // croppedCanvas（トリミング後の画像をプレビューとして表示するための部分）のコーディング
  var croppedCanvas
  function iconCropping () {
    if (!croppable) {
      alert('トリミングする画像が設定されていません。')
      return false
    }
    croppedCanvas = cropper.getCroppedCanvas({
      width: 800,
      height: 800
    })
    var croppedImage = document.createElement('img')
    croppedImage.src = croppedCanvas.toDataURL()

    // 画像アップロード
    Ajax.setPrivateKartePhoto(kSuid, kSuidbase, photoid, croppedImage.src, (result) => {
      // nothing to do
    })
  }

  // トリミング決定時
  $('.select_icon_btn').on('click', function () {
    iconCropping()
    $('.overlay').fadeOut()
    $('#crop_img').remove()
    $('.cropper-container').remove()
  })

  // トリミング画面を閉じる時
  $('.close_btn').on('click', function () {
    $('.overlay').fadeOut()
    $('#crop_img').remove()
    $('.cropper-container').remove()
  })
})

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
  }
}
